<template>
  <v-dialog
    id="NOTIFICATION"
    v-model="value"
    hide-overlay
    persistent
    dark
    content-class='notif-dialog'
  >
  <v-layout justify-center>
    <v-flex md8 lg6>
    <v-card color="secondary" class="white--text elementVisor2 elevation-5 my-4">
      <v-btn @click="close" class="mt-3" absolute right icon dark>
        <v-icon>clear</v-icon>
      </v-btn>
      <v-layout wrap justify-center py-3 px-3 align-center :column='$vuetify.breakpoint.xsOnly' :row="!$vuetify.breakpoint.xsOnly">
        <v-flex mr-2 xs12 sm3 class="text-xs-center">
          <v-icon v-if="transaction.student.imageStorage == null" color="primary" size="90">school</v-icon>
          <v-avatar v-else size="150">
            <v-img :src="transaction.student.imageStorage.miniObjUrl"></v-img>
          </v-avatar>
        </v-flex>
        <v-flex sm8>
          <h1 class="display-1 pr-5">{{ transaction.student.firstName + " " + transaction.student.lastName}}</h1>
          <h3 class="headline" v-show="transaction.student.gg"> {{ 'Grupo ' + (transaction.student.gg && transaction.student.gg.grade || '') + (transaction.student.gg && transaction.student.gg.group || '') }} </h3>
          <h3 class="headline">{{ transaction.door.doorName + ", "+
              (new Date(transaction.requestedTime).getHours() % 12 || 12) +
              ":"+
              (new Date(transaction.requestedTime).getMinutes() < 10 ? "0"+new Date(transaction.requestedTime).getMinutes() : new Date(transaction.requestedTime).getMinutes()) +
              (new Date(transaction.requestedTime).getHours() >= 12 ? " p.m." : " a.m.")}}</h3>
          <h3 class="headline" v-if="transaction.personRequesting || transaction.parent">{{ transaction.personRequesting || transaction.parent.firstName + " " + transaction.parent.lastName}}</h3>
          <h3 class="headline" v-if="transaction.car && transaction.car.id != 0">{{ transaction.car.model+", "+transaction.car.color+" - "+transaction.car.plates}}</h3>
          <h3 class="headline" v-else>{{ 'Caminando' }}</h3>
        </v-flex>
      </v-layout>
    </v-card>
    </v-flex>
  </v-layout>
  </v-dialog>
</template>

<script>
import { setTimeout } from "timers";
export default {
  props: ["value", "transaction", "settings"],
  data: () => ({}),
  watch: {
    value() {
      if (this.value) {
        if (!this.settings.mute) {
          var audio = new Audio(require("@/" + this.settings.sound));
          audio.play();
        }
        //this.getImage();
        setTimeout(() => {
          this.$emit("closed");
        }, this.settings.time * 300);
      }
    }
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    getImage() {
      this.$store
        .dispatch("student/getImage", this.transaction.student.id)
        .then(response => {
          if (response.data.entity.image != "") {
            this.transaction.img =
              "data:image/jpg;base64, " + response.data.entity.image;
            this.$forceUpdate();
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style>
.v-dialog.notif-dialog {
  box-shadow: none;
}
@media (min-width: 600px) {
  .elementVisor2 {
    border-top-left-radius: 600px !important;
    border-bottom-left-radius: 600px !important;
  }
}
</style>

<style scoped>
/* /deep/ .v-dialog.v-dialog--active.v-dialog--persistent {
  border-top-left-radius: 600px !important;
  border-bottom-left-radius: 600px !important;
} */
</style>
